import * as Utils from 'Assets/Utils'

import ClientHttpRequest from 'Api/ClientHttpRequest'
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from "Modules/Loading"

const initialState = Immutable.Map({})
	.set('Add', new Immutable.Map({}))
	.set('Status', new Immutable.Map({}))
	.set('Description', new Immutable.Map({}))
	.set('Get', new Immutable.Map({}))
	.set('Search', new Immutable.List([]))

/* Types */
export const ACTION_ADD_CHECK = 'ACTION_ADD_CHECK'
export const ACTION_GET_STATUS_CHECK = 'ACTION_GET_STATUS_CHECK'
export const ACTION_GET_DESCRIPTION_CHECK = 'ACTION_GET_DESCRIPTION_CHECK'
export const ACTION_GET_DATA_CHECK = 'ACTION_GET_DATA_CHECK'
export const ACTION_SEARCH_CHECK_DONATION = 'ACTION_SEARCH_CHECK_DONATION'



/* Reducer */

export default (state = initialState, action) => {
	switch (action.type) {
		case ACTION_ADD_CHECK:
			return state.set('Add', new Immutable.Map(action.Obj))
		case ACTION_GET_STATUS_CHECK:
			return state.set('Status', new Immutable.Map(action.Obj))
		case ACTION_GET_DESCRIPTION_CHECK:
			return state.set('Description', new Immutable.Map(action.Obj))
		case ACTION_GET_DATA_CHECK:
			return state.set('Get', new Immutable.Map(action.Obj))
		case ACTION_SEARCH_CHECK_DONATION:
			return state.set('Search', new Immutable.List(action.Obj))
		default:
			return state
	}
}

/* Action Creators */
export const addCheckDonative = (form) => {

	let temp = {
		id: form.idSearchCheck || null,
		idEstatusAplicacion: null,
		descripcion: form.descriptionDonation,
		deleted: form.newStatusCheck,
		retroalimentacion: form.feedbackDonation,
		dePorcentaje: parseFloat(form.ofPercent),
		hastaPorcentaje: parseFloat(form.untilPercent),
		deMonto: parseFloat(form.ofNumber),
		hastaMonto: parseFloat(form.untilNumber),
		usuario: sessionStorage.uid
	}

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: form.idSearchCheck ? "api/updateDataCheckDonation" : "api/addCheckDonative",
			method: "POST",
			data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then((response) => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_ADD_CHECK, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getStatusCheck = (form) => {

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: "api/getStatusCheck",
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then((response) => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_STATUS_CHECK, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const updateDataCheckDonation = () => {
	
	return (dispatch) => {
		dispatch(isLoading(true))

		return ClientHttpRequest({
			servie: "api/updateDataCheckDonation",
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then((response) => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_DATA_CHECK, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const searchCheckDonation = (form) => {

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: Object.keys(form).length ? "api/searchCheckDonationByParams" : "api/searchCheckDonation",
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then((response) => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_SEARCH_CHECK_DONATION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const clearCheckDonation = () => {
	return(dispatch) => {
		dispatch({type: ACTION_SEARCH_CHECK_DONATION, Obj: []})
	}
}




// WEBPACK FOOTER //
// ./src/modules/Configurations/DonationCheck/CheckStatus.js